<template>
  <div v-if="visible">
    <div class="modal d-block" tabindex="-1" role="dialog" @click.self="$emit('close')">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content border-0 rounded-4">
          <div class="modal-header">
            <h5 class="modal-title">Channel-Info</h5>
            <button type="button" class="btn-close" aria-label="Schließen" @click="$emit('close')"></button>
          </div>
          <div class="modal-body">
            <h5 class="mb-1">{{ channel.display_name }}</h5>
            <p v-if="channel.header" class="fst-italic text-muted mb-2">{{ channel.header }}</p>
            <div class="text-muted small mb-2">{{ typeLabel }}</div>
            <div><i class="fas fa-users me-1 text-muted"></i> {{ channel.member_count || 0 }} Mitglieder</div>
          </div>
          <div class="modal-footer">
            <button v-if="channel.channel_type === 'P' && channel.name !== 'town-square'" type="button"
             class="btn btn-outline-danger btn-sm" @click="$emit('leave')">
              <i class="fas fa-sign-out-alt me-1"></i> Channel verlassen
            </button>
            <button type="button" class="btn btn-secondary btn-sm" @click="$emit('close')">Schließen</button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-backdrop fade show"></div>
  </div>
</template>

<script>
export default {
  name: 'ChannelInfoModal',
  props: {
    visible: {type: Boolean, default: false},
    channel: {type: Object, default: () => ({})},
  },
  computed: {
    typeLabel() {
      const t = this.channel.channel_type
      if (t === 'D') return 'Direktnachricht'
      if (t === 'E') return 'Aussteller-Kanal'
      if (t === 'P') return 'Öffentlicher Kanal'
      return ''
    },
  },
}
</script>
